import React from "react";
import { variations } from "./variations";

export default function ProductThemeWrapper({ variant = "purple", children }) {
	const themeVars = variations[variant];

	return (
		<div
			style={{
				"--product-color": themeVars?.color,
				"--product-bg-overlay": themeVars?.bgOverlay,
			}}
		>
			{children}
		</div>
	);
}
